import { ScaleOrdinal } from 'd3-scale';
import { isUndefined } from 'lodash-es';

import { getValidColor } from './getValidColor.js';
import { LegendItem } from '../components/legend/categorical/types/legend.js';

/**
 * Defines the items to render in a categorical legend
 * @internal
 */
export const buildCategoricalItemsFromScale = (
  scale: ScaleOrdinal<string, string>,
) => {
  const categories = scale.domain();

  const legendItems: LegendItem[] = [];
  categories.forEach((category) => {
    const color = scale(category);
    if (!isUndefined(color)) {
      legendItems.push({
        id: crypto.randomUUID(),
        color: { Default: getValidColor(color) },
        name: category,
      });
    }
  });

  return legendItems;
};
